import en from './en.json';
import fr from './fr.json';

const allMessages = {
	en,
	fr,
};

export default allMessages;
